export const CREATE_APPOINTMENT_VACCINE_REQUEST = 'CREATE_APPOINTMENT_VACCINE_REQUEST'
export const CREATE_APPOINTMENT_VACCINE_SUCCESS = 'CREATE_APPOINTMENT_VACCINE_SUCCESS'
export const CREATE_APPOINTMENT_VACCINE_FAIL = 'CREATE_APPOINTMENT_VACCINE_FAIL'
export const CREATE_APPOINTMENT_VACCINE_RESET = 'CREATE_APPOINTMENT_VACCINE_RESET'


export const LIST_APPOINTMENT_VACCINE_REQUEST = 'LIST_APPOINTMENT_VACCINE_REQUEST'
export const LIST_APPOINTMENT_VACCINE_SUCCESS = 'LIST_APPOINTMENT_VACCINE_SUCCESS'
export const LIST_APPOINTMENT_VACCINE_FAIL = 'LIST_APPOINTMENT_VACCINE_FAIL'
export const LIST_APPOINTMENT_VACCINE_RESET = 'LIST_APPOINTMENT_VACCINE_RESET'

export const DELETE_APPOINTMENT_VACCINE_REQUEST = 'DELETE_APPOINTMENT_VACCINE_REQUEST'
export const DELETE_APPOINTMENT_VACCINE_SUCCESS = 'DELETE_APPOINTMENT_VACCINE_SUCCESS'
export const DELETE_APPOINTMENT_VACCINE_FAIL = 'DELETE_APPOINTMENT_VACCINE_FAIL'

export const UPDATE_APPOINTMENT_VACCINE_REQUEST = 'UPDATE_APPOINTMENT_VACCINE_REQUEST'
export const UPDATE_APPOINTMENT_VACCINE_SUCCESS = 'UPDATE_APPOINTMENT_VACCINE_SUCCESS'
export const UPDATE_APPOINTMENT_VACCINE_FAIL = 'UPDATE_APPOINTMENT_VACCINE_FAIL'
export const UPDATE_APPOINTMENT_VACCINE_RESET = 'UPDATE_APPOINTMENT_VACCINE_RESET'


export const DETAILS_APPOINTMENT_VACCINE_REQUEST = 'DETAILS_APPOINTMENT_VACCINE_REQUEST'
export const DETAILS_APPOINTMENT_VACCINE_SUCCESS = 'DETAILS_APPOINTMENT_VACCINE_SUCCESS'
export const DETAILS_APPOINTMENT_VACCINE_FAIL = 'DETAILS_APPOINTMENT_VACCINE_FAIL'

export const LIST_TAKEN_ENUMS_REQUEST = 'LIST_TAKEN_ENUMS_REQUEST'
export const LIST_TAKEN_ENUMS_SUCCESS = 'LIST_TAKEN_ENUMS_SUCCESS'
export const LIST_TAKEN_ENUMS_FAIL = 'LIST_TAKEN_ENUMS_FAIL'
export const LIST_TAKEN_ENUMS_RESET = 'LIST_TAKEN_ENUMS_RESET'

export const LIST_DAY_ENUMS_REQUEST = 'LIST_DAY_ENUMS_REQUEST'
export const LIST_DAY_ENUMS_SUCCESS = 'LIST_DAY_ENUMS_SUCCESS'
export const LIST_DAY_ENUMS_FAIL = 'LIST_DAY_ENUMS_FAIL'
export const LIST_DAY_ENUMS_RESET = 'LIST_DAY_ENUMS_RESET'
